import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouterModule } from "@angular/router";
import { MatCardModule } from "@angular/material/card";
import { FormsModule } from "@angular/forms";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { GoogleMapsModule } from '@angular/google-maps';
import { CustomPipesModule } from "../shared/custom-pipes/custom-pipes.module";
import { SharedComponentModule } from "../shared/components/shared-component.module";
import { I18nModule } from "../i18n/i18n.module";
import { MobileComponent } from "./mobile.component";
import { MobileHomeComponent } from "./home/home.component";
import { ReturnItemComponent } from "./return-item/return-item.component";
import { LoginPageComponent } from "./login/login.component";
import { ConfirmReturnComponent } from "./confirm-return/confirm-return.component";
import { ReturnCreatedComponent } from "./return-created/return-created.component";
import { LandingPageComponent } from "./landing-page/landing-page.component";
import { DeliveryOptionsComponent } from "./delivery-options/delivery-options.component";
import { MBrandingComponent } from "./branding/branding.component";
import { MAddItemComponent } from "./add-item/add-item.component";
import { UpdateAddressComponent } from "./delivery-options/update-address/update-address.component";
import { MScreenComponent } from "./screen-header/screen-header.component";
import { MErrorComponent } from "./errors/error.component";

@NgModule({
  declarations: [
    MobileComponent,
    LoginPageComponent,
    LandingPageComponent,
    ConfirmReturnComponent,
    MobileHomeComponent,
    ReturnItemComponent,
    ReturnCreatedComponent,
    DeliveryOptionsComponent,
    UpdateAddressComponent,
    MBrandingComponent,
    MAddItemComponent,
    MScreenComponent,
    MErrorComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule,
    CustomPipesModule,
    MatCardModule,
    SharedComponentModule,
    FormsModule,
    NgbModule,
    I18nModule,
    GoogleMapsModule
  ],
  exports: [
    MobileComponent,
    LoginPageComponent,
    LandingPageComponent,
    ConfirmReturnComponent,
    MobileHomeComponent,
    ReturnItemComponent,
    ReturnCreatedComponent,
    DeliveryOptionsComponent,
    MBrandingComponent,
    MAddItemComponent,
    MScreenComponent,
    MErrorComponent,
  ],

  providers: [],
})
export class MobileModule {}
